export function calculateMarkup(cost: number, price: number): number {
  return ((price - cost) * 100) / cost
}

export function calculatePrice(cost: number, markup: number): number {
  return cost + (cost * markup) / 100
}
